/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React from 'react';

interface Props {
    className?: string;
}

export default function SuccessIcon(props: Props) {
    const {className} = props;

    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g clipPath="url(#clip0_480_788)">
                <circle
                    cx="14"
                    cy="14"
                    r="14"
                    fill="rgba(76, 175, 80, 0.25)"
                />
                <circle
                    cx="14"
                    cy="14"
                    r="9"
                    fill="none"
                    stroke="#4CAF50"
                    strokeWidth="1.68"
                />
                <circle
                    cx="14"
                    cy="14"
                    r="8"
                    fill="white"
                />
                <path
                    d="M 10.64 15.4 L 12.88 17.64 L 17.92 11.76"
                    fill="none"
                    stroke="#4CAF50"
                    strokeWidth="2.24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
